<template>
	<div>
		<div class="bg">
			<div class="container">
				<div
					style="display: flex;flex-direction: column;padding-bottom: 1rem;border-bottom: 1px solid #454545;;">
					<div style="" class="footer-box">
						<div style="display: flex;flex-direction: column;width: 18rem;margin-right: 2rem;flex: 1;">
							<img src="../../src/assets/imgs/footer-logo.png" alt="" style="width: 7.5rem;height: 3rem;">
							<div style="cursor: pointer;" @click="go('about', {})" class="footer-l-text">
								Globalcare-Info is a pioneer in the field of global business information services,
								building close connections across various global industry chains through its powerful
								digital platform.
								<!-- Globalcare-Info merges the forefront of international business consultancy with a dynamic digital platform, crafting vital connections across global industry chains. -->
							</div>
							<div style="margin-top: 1rem;display: flex;" v-if="indexdata.contactUs">
								<!-- fackbook -->
								<img src="../../src/assets/imgs/footer-icon-1.png" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.facebook)">
								<!-- twitter -->
								<img src="../../src/assets/imgs/footer-icon-2.png" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.twitter)">
								<!-- instagram -->
								<img src="../../src/assets/imgs/footer-icon-3.png" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.instagram)">
								<!-- LinkedIn -->
								<img src="../../src/assets/imgs/footer-icon-4.png" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.linkedin)">
								<!-- youtube -->
								<img src="../../src/assets/imgs/footer-icon-5.png" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.youtube)">
								<!-- whatsapp -->
								<img src="../../src/assets/imgs/footer-icon-6.png" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.whatsapp)">
								<!-- tiktok -->
								<img src="../../src/assets/imgs/footer-icon-7.svg" alt="" class="footer-icon"
									@click="openurl(indexdata.contactUs.tikTok)">
							</div>
						</div>

						<div class="row footer-row" style="">
							<div class="wow fadeInUp animated col-q1" style="display: flex;flex-direction: column;">
								<span class="footer-right-title" @click="go('newsmain', {})">Information</span>
								<span class="footer-right-text" @click="toNewslist({ title: 0, item: 0 })">Industry
									Information</span>
								<span class="footer-right-text" @click="toNewslist({ title: 1, item: 0 })">Events</span>
								<span class="footer-right-text" @click="toNewslist({ title: 2, item: 0 })">GCI
									Insights</span>
							</div>
							<div class="wow fadeInUp animated col-q2" style="display: flex;flex-direction: column;"
								data-wow-delay="0.2s">
								<span class="footer-right-title" @click="go('circletopic', {})">Discussion</span>
								<span class="footer-right-text" @click="go('circletopic', { id: 1 })">Sanitary
									Care</span>
								<span class="footer-right-text" @click="go('circletopic', { id: 2 })">Tourism
									Care</span>
								<span class="footer-right-text" @click="go('circletopic', { id: 4 })">Pet Care</span>
								<span class="footer-right-text" @click="go('circletopic', { id: 3 })">Food Care</span>
								<span class="footer-right-text" @click="go('circletopic', { id: 5 })">Home Care</span>
							</div>
							<div class="wow fadeInUp animated col-q3" style="display: flex;flex-direction: column"
								data-wow-delay="0.4s">
								<span class="footer-right-title">Services</span>
								<span class="footer-right-text" @click="go('expert', {})">Consultant</span>
								<span class="footer-right-text" @click="go('supplierlist', {})">Service Providers</span>
							</div>

							<div class="wow fadeInUp animated col-q4" style="display: flex;flex-direction: column;"
								:style="isMobile ? null : 'margin-right: 1rem;'" data-wow-delay="0.6s">
								<span class="footer-right-title">Demands Publishing</span>
								<!-- <span class="footer-right-text" @click="todemandmain(1)">Material requirement</span> -->
								<span class="footer-right-text" @click="todemandmain(demand.id)"
									v-for="(demand, demandindex) in demanddata" :key="demandindex">{{ demand.title
									}}</span>
							</div>
							<div class="wow fadeInUp animated col-q5" style="display: flex;flex-direction: column;"
								data-wow-delay="0.7s">
								<span class="footer-right-title">Product</span>
								<!-- <span class="footer-right-text" @click="todemandmain(1)">Material requirement</span> -->
								<span class="footer-right-text" @click="toProduct(demand.id)"
									v-for="(demand, demandindex) in categories" :key="demandindex">{{ demand.name
									}}</span>
							</div>
							<div class="wow fadeInUp animated col-q6" style="display: flex;flex-direction: column"
								data-wow-delay="0.8s">
								<span class="footer-right-title" style="cursor: pointer;" @click="go('about', {})">About
									Us</span>
								<!-- <span class="footer-right-text">Team Members</span>
								<span class="footer-right-text">Partners</span>
								<span class="footer-right-text">Contact Us</span> -->
							</div>
						</div>
					</div>
				</div>

				<div style="display: flex;margin-top: 1rem;" class="footer-bottom-box">
					<div style="flex: 1;color: #fff;font-weight: 400;font-size: 0.8rem;">Copyright © 2023 All rights
						reserved</div>
					<div class="footer-bottom" style="cursor: pointer;">
						<span class="footer-bottom-text" @click="toweb">Web Agreement</span>
						<span class="footer-bottom-text" style="margin-left: 1rem;">Technical Support: OOINTER</span>
					</div>
					<!-- <div class="footer-bottom-text">Data privacy</div>
					<div class="footer-bottom-text">Cookie settings</div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			indexdata: {
				contactUs: {}
			},
			categories: [],
			demanddata: []
		}
	},
	components: {
	},
	filters: {
	},
	methods: {
		toProduct(id) {
			this.$router.push({ name: 'productList', query: { categoryId: id } })
			location.reload()
		},
		async getdata() {
			let res3 = await this.$get('/categories')
			this.categories = res3.data.items
		},
		toNewslist(obj) {
			let params = obj
			localStorage.setItem('newslist', JSON.stringify(params))
			this.$router.push({ name: 'newslist' }).catch(data => { })
			location.reload();
		},
		go(url, item) {
			this.$router.push({ name: url, query: item })
			location.reload()
		},
		toweb() {
			// this.$router.push({name:'agreement'})
			let routeUrl = this.$router.resolve({
				name: "agreement"
			});
			window.open(routeUrl.href, '_blank');
		},
		getdemand() {
			this.request({
				method: 'get',
				url: '/gci/demand/classify'
			}).then(res => {
				this.demanddata = res.data.items
			}).catch(error => {
				console.error(error.response)
			})
		},
		getindex() {
			this.request({
				url: '/gci/index',
				method: 'get'
			}).then(res => {
				this.indexdata = res.data
			}).catch(error => {
				console.error(error.response)
			})
		},
		openurl(url) {
			window.open(url)
		},
		todemandmain(id) {
			this.$router.push({ name: 'demandmain', query: { id: id } })
			location.reload()
		},
	},
	mounted() {
		this.getindex()
		this.getdemand()
		this.getdata();
	}
}

</script>


<style scoped lang="scss">
.bg {
	background-color: #091B2C;
	padding: 3rem 0 1rem;
	// z-index: 960;
	z-index: 4;
	position: relative;
}

.footer-icon {
	width: 2rem;
	height: 2rem;
	margin-right: 0.5rem;
	cursor: pointer;
}

.footer-right-title {
	color: #fff;
	font-size: 1.25rem;
	font-weight: 500;
}

.footer-right-text {
	color: #9D9D9D;
	font-size: 0.8rem;
	font-weight: 500;
	margin-top: 0.5rem;
	cursor: pointer;
}

.footer-right-text:hover {
	color: #62e0c9;
}

.footer-bottom-text {
	font-size: 0.8rem;
	font-weight: 400;
	color: #fff;
	// margin-left: 1rem;
}

.footer-bottom-text:hover {
	color: #62e0c9;
}

.footer-l-text {
	margin-top: 1rem;
	font-size: 0.8rem;
	color: #fff;
	font-weight: 400;
}

.footer-l-text:hover {
	color: #62e0c9;
}

.footer-box {
	display: flex;

	.footer-row {

		display: flex;
		width: calc(100% - 20rem);
		justify-content: flex-start;
	}
}

.col-q1 {
	flex: 0 0 20%
}

.col-q2 {
	flex: 0 0 18%
}

.col-q3 {
	flex: 0 0 16%
}

.col-q4 {
	flex: 0 0 26%
}

.col-q5 {
	flex: 0 0 14%
}

@media (max-width: 767px) {
	.footer-box {
		display: block;

		.footer-row {
			display: flex;
			width: auto;
			justify-content: left;
			padding: 1rem;

			.col-q1 {
				flex: 0 0 50%
			}

			.col-q2 {
				flex: 0 0 50%
			}

			.col-q3 {
				flex: 0 0 50%
			}

			.col-q4 {
				flex: 0 0 50%
			}

			.col-q5 {
				flex: 0 0 50%
			}

			.footer-right-title {
				margin-top: 1rem;
			}
		}
	}

	.footer-bottom {
		display: flex;
		justify-content: flex-start;
	}

	.footer-bottom-box {
		flex-direction: column;
	}
}
</style>